import React, { useMemo } from "react";
import { NoticeBarWrapper, useStylesToolTip } from "./under-nda-banner.styles";
import { Tooltip } from "@material-ui/core";
import { NoticeBarProps } from "./under-nda-banner.props";
import { withShowIf } from "../../../../components/with-show-if/with-show-If.component";
import { createUnderNdaBannerTooltipText } from "../../types/under-nda-banner/under-nda-banner.functions";

export const UnderNdaBanner = withShowIf((props: NoticeBarProps) => {
  const classes = useStylesToolTip();

  const ndaUsers = useMemo(
    () => (props.underNdaUserDetails.length ? props.underNdaUserDetails : []),
    [props.underNdaUserDetails]
  );
  const otherUsers = useMemo(() => (ndaUsers.length > 3 ? ndaUsers.slice(2) : []), [ndaUsers]);
  const tooltipText = useMemo(() => createUnderNdaBannerTooltipText(otherUsers), [otherUsers]);

  return (
    <>
      <NoticeBarWrapper>
        <>
          <strong>Under NDA.</strong>&nbsp;
          {ndaUsers.length > 0 && "Visible to "}
          {ndaUsers.length <= 3 && (
            <>
              {ndaUsers.map((user, index) =>
                index === ndaUsers.length - 1
                  ? `${ndaUsers.length === 1 ? "" : " and"} ${user.firstName} ${user.lastName}.`
                  : ` ${user.firstName} ${user.lastName}${
                      index === ndaUsers.length - 2 ? "" : ", "
                    }`
              )}
            </>
          )}
          {ndaUsers.length > 3 && (
            <>
              {ndaUsers
                .slice(0, 2)
                .map((user, index) =>
                  index === ndaUsers.length - 1
                    ? ` and ${user.firstName} ${user.lastName}.`
                    : ` ${user.firstName} ${user.lastName}${index === 1 ? "" : ", "}`
                )}{" "}
              and{" "}
              <Tooltip arrow classes={classes} title={tooltipText}>
                <span>{ndaUsers.slice(2).length} others</span>
              </Tooltip>
              .
            </>
          )}
        </>
      </NoticeBarWrapper>
    </>
  );
});
